'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _muiThemeable = require('material-ui/styles/muiThemeable');

var _muiThemeable2 = _interopRequireDefault(_muiThemeable);

var _materialUi = require('material-ui');

var _colors = require('material-ui/styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The action area of a notifaction as shown in https://material.io/guidelines/patterns/notifications.html#notifications-anatomy-of-a-notification
 * and adjusted for the web.
 * 
 * @author Timo Hanisch <timohanisch@googlemail.com>
 * @since 0.1.0
 */
var NotificationActionArea = function (_React$PureComponent) {
    _inherits(NotificationActionArea, _React$PureComponent);

    function NotificationActionArea() {
        _classCallCheck(this, NotificationActionArea);

        return _possibleConstructorReturn(this, (NotificationActionArea.__proto__ || Object.getPrototypeOf(NotificationActionArea)).apply(this, arguments));
    }

    _createClass(NotificationActionArea, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                actions = _props.actions,
                muiTheme = _props.muiTheme,
                primaryColor = _props.primaryColor;

            var styles = {
                // Inline style which is relies on dynamic information
                buttonLabel: _extends({
                    color: primaryColor || muiTheme.palette.primary1Color
                }, NotificationActionArea.STYLES.buttonLabel)
            };
            return _react2.default.createElement(
                'div',
                { style: NotificationActionArea.STYLES.container },
                actions.map(function (action, index) {
                    return _react2.default.createElement(_materialUi.FlatButton, {
                        key: 'nAction_' + index,
                        label: action.label,
                        style: index > 0 ? _extends({}, NotificationActionArea.STYLES.button, { marginLeft: 8 }) : NotificationActionArea.STYLES.button,
                        labelStyle: styles.buttonLabel,
                        onClick: action.onClick
                    });
                })
            );
        }
    }]);

    return NotificationActionArea;
}(_react2.default.PureComponent);
// Use Material-UI HOC to get access to the used primary color


NotificationActionArea.propTypes = {
    /* An array of action objects which are shown as flat buttons at the bottom of the notification */
    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        onClick: _propTypes2.default.func.isRequired
    })).isRequired,

    /* By default notifications use the primary1color defined for the material-ui theme for the header and actions. */
    primaryColor: _propTypes2.default.string
};
NotificationActionArea.defaultProps = {
    primaryColor: ''
};
NotificationActionArea.STYLES = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        padding: 8,
        backgroundColor: _colors.grey200
    },
    button: {
        minWidth: null // We do not want the default width of 88px
    },
    buttonLabel: {
        padding: '0 8px 0 8px'
    }
};
exports.default = (0, _muiThemeable2.default)()(NotificationActionArea);
module.exports = exports['default'];